import React from 'react';
import { useParams } from 'react-router-dom';
import { PAGE_COMMON_TEXT } from '../lang';
import { waitingForProcessing } from '../WaitProcess';
import {
  useGetApplicationVisaDetail,
  VISA_STATUS,
} from '../../../AcademicRegistry';
import { VisaApplicationForm } from '../../../AcademicRegistry/components/VisaApplication/VisaApplicationForm';
import { Loading, Alert, Accordion } from '../../../../components';

export const VisaApplicationView: React.FunctionComponent = () => {
  const { applicationId } = useParams();

  const { applicationVisaDetail, error, loading } = useGetApplicationVisaDetail(
    {
      applicationId: {
        eq: applicationId,
      },
    },
  );

  if (error) {
    return (
      <Alert
        openAlert={true}
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }

  const hasVisaApplication = Object.values(VISA_STATUS).includes(
    applicationVisaDetail?.status,
  );

  return (
    <>
      {loading ? (
        <Loading />
      ) : hasVisaApplication ? (
        <Accordion
          title={PAGE_COMMON_TEXT.SIDEBAR_TEXT.VISA_APPLICATION}
          defaultExpanded
          details={
            <VisaApplicationForm
              viewMode={true}
              applicationVisaDetail={applicationVisaDetail}
            />
          }
        />
      ) : (
        waitingForProcessing(PAGE_COMMON_TEXT.SIDEBAR_TEXT.VISA_APPLICATION)
      )}
    </>
  );
};
